<template>
  <div class="about">
    <div class="content ibtns">
      <div class="sx">
        <button class="btn new-t-btn c" @click.stop="route('/d/proc');">
          <img alt="" src="../assets/imgs/push1.svg" width="16" height="16">
          <p>发起申请</p>
        </button>
      </div>
      <div class="sx" v-if="isShowRecordBtn()">
        <button class="btn normal-btn c" @click.stop="route('/proc/record');">
          <img alt="" src="../assets/imgs/file.svg" width="20" height="20">
          <p>申请记录</p>
        </button>
      </div>
    </div>
    <div class="content list">
      <!--菜单-->
      <div class="c nav-search">
        <div :class="isPhone ? 'navs-m' : 'navs'">
          <p v-for="(key, i) in listKeys"
             :key="i"
             @click="openList(key)"
             :class="{'active a': key === curTaskList, 'search-show': hasSearchResult}">{{ taskInfo[key][isPhone ? 'nameSimple' : 'name'] }} ({{
              taskInfo[key].data.total
            }})</p>
        </div>
        <!--form解决google浏览器自动填充问题-->
        <form @submit.prevent="0">
          <el-input
              placeholder="请输入需要搜索的内容"
              prefix-icon="el-icon-search"
              :clearable="true"
              v-model="searchText"
              @change="search()">
          </el-input>
        </form>
      </div>
      <!--任务列表-->
      <ProcList v-for="(key, i) in listKeys" :key="i" :proc-list="taskInfo[key].data.list" :list-key="key" v-show="curTaskList === key"></ProcList>
      <!--分页-->
      <div class="page-nav c" v-if="curTaskList">
        <el-pagination
            @current-change="jumpPage"
            :current-page.sync="taskInfo[curTaskList].data.pageNum"
            :page-size="taskInfo[curTaskList].data.pageSize"
            layout="total, prev, pager, next"
            :total="taskInfo[curTaskList].data.total">
        </el-pagination>
      </div>
      <!--仅为了防止div大小变化页面抖动-->
      <div class="page-nav c" v-else="">
        <a href="javascript:void(0)"> </a>
      </div>
    </div>
    <!--用于审批记录展示-->
    <div id="history-tip-content" style="display:none;">
      <ul style="background: #516079;">
        <li class="layui-timeline-item" v-for="(h, ih) in curHistory" :key="ih">
          <i class="layui-icon layui-timeline-axis">
            <img alt="" v-if="h.actName === '结束'" src="@/assets/imgs/done.svg">
            <img alt="" v-else src="@/assets/imgs/round.svg">
          </i>
          <div class="layui-timeline-content layui-text">
            <p class="layui-timeline-title">{{ h.assignee && (h.assignee + ' ') }}{{ h.actName }}</p>
            <p class="tip-time">{{ h.startTime }}</p>
          </div>
        </li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import "../assets/styles/shenpi.css";
import "../assets/styles/shenpi-m.css";
import TaskListInfo from '@/assets/models/task-list-info'
import ProcList from "@/components/ProcList";

const listKeys = Object.keys(TaskListInfo);
export default {
  components: { ProcList },
  data() {
    return {
      listKeys: listKeys,
      taskInfo: TaskListInfo,
      curTaskList: 'todo',
      showProcBtns: false,
      imgs: [],
      curHistory: null,
      tipId: null,
      searchText: ''
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isPhone() {
      return window.innerWidth <= 769
    },
    excludeLastListKeys() {
      return this.listKeys.filter((item, i) => i !== this.listKeys.length - 1)
    },
    hasSearchResult() {
      return this.taskInfo.search.data.total > 0
    }
  },
  methods: {
    isShowRecordBtn() {
      if (!this.user) return false
      let isShowBtn = false;
      if (['江山', '曹海琴'].indexOf(this.user.name) !== -1) return true
      let gs = this.user.groups;
      if (gs) {
        gs.forEach(g => {
          if (g.id === '采购&财务部' || g.id.indexOf('主管') !== -1) isShowBtn = true;
        })
      }
      return isShowBtn;
    },
    route(link) {
      this.$router.push(link)
    },
    loadAllData() {
      listKeys.forEach(key => this.loadList(key))
    },
    loadList(listName, page = 1) {
      let api, params;
      if (listName === 'search') {
        if (!this.searchText) return
        api = this.taskInfo.search.tempApi
        params = {
          userId: this.user.name,
          page: page,
          searchText: this.searchText
        }
      } else {
        api = this.taskInfo[listName].api
        params = {
          userId: this.user.name,
          page: page
        }
      }
      if (!this.user || !api) return
      this.$get(api, params, res => {
        this.taskInfo[listName].data = res
      })
    },
    openList(listName) {
      localStorage.setItem('sp-last-task-list', listName)
      this.curTaskList = listName
    },
    jumpPage(page) {
      this.loadList(this.curTaskList, page)
    },
    showHistoryTip(task) {
      var self = this;
      if (self.tipHistoryLoading)
        return
      window.layer.close(self.tipId)
      self.tipHistoryLoading = true;
      let $target = event.currentTarget
      this.$get('/sp/process/history', { procInstId: task.procInstId }, res => {
        self.curHistory = res;
        self.tipHistoryLoading = false;
        this.$nextTick(() => {
          // setTimeout(() => {
          let content = this.$('#history-tip-content');
          self.tipId = window.layer.tips(content.html(), $target, {
            tips: [1, 'rgb(80, 95, 121)'],
            time: 10000,
            success(dom) {
              let newLeft = dom.css('left').replace('px', '') - 10 + 'px';
              dom.css('left', newLeft);
            },
            end() {
              self.tipId = null;
            }
          });
          // }, 50)
        })
      })
    },
    search() {
      console.log('search: ', this.searchText)
      this.curTaskList = 'search'
      this.loadList('search')
    }
  },
  mounted() {
    window.$shenpi = this;
  },
  created() {
    let lastList = localStorage.getItem('sp-last-task-list');
    this.curTaskList = lastList || 'todo'
    this.loadAllData()
  },
  watch: {
    user(newUser) {
      if (newUser)
        listKeys.forEach(this.loadList)
    }
  },
  provide() {
    return {
      componentShenpi: this
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === '审批系统' && to.params.reloadData)
      this.loadAllData();
    next()
  },
};
</script>

<style scoped>
.v-s-w {
  height: 33px;
  padding: 0 8px;
}

.t {
  height: auto
}

.layui-text {
  line-height: 22px;
  font-size: 14px;
  color: #fff;
}

.ibtns .sx button {
  margin: 0 0 10px 0;
}

.nav-search {
  justify-content: space-between;
}

.navs > p:last-child,
.navs-m > p:last-child {
  display: none;
}

.navs > p.search-show:last-child,
.navs-m > p.search-show:last-child {
  display: block;
}

.nav-search .el-input {
  width: auto;
  margin: 10px 5px 0 0;
}

@media only screen and (max-width: 749px) {
  .nav-search {
    flex-direction: column;
  }

  .nav-search .el-input, .nav-search form {
    width: 100%;
  }
}
</style>
